import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Cart() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: 'طماطم طازجة',
      price: 8.50,
      originalPrice: 10.00,
      unit: 'كيلو',
      quantity: 2,
      image: 'https://public.readdy.ai/ai/img_res/143b8972c79a3e303c7e643954858e86.jpg',
      storeName: 'بقالة الأمانة'
    },
    {
      id: 2,
      name: 'تفاح أحمر',
      price: 12.00,
      unit: 'كيلو',
      quantity: 1,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20red%20apples%2C%20premium%20quality%20fruit%20photography%2C%20clean%20white%20background%2C%20realistic%20food%20photography%2C%20appetizing%20presentation&width=80&height=80&seq=apple-cart&orientation=squarish',
      storeName: 'بقالة الأمانة'
    },
    {
      id: 3,
      name: 'حليب طازج',
      price: 6.50,
      unit: 'لتر',
      quantity: 3,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20milk%20bottle%2C%20dairy%20product%20photography%2C%20clean%20white%20background%2C%20realistic%20product%20photography%2C%20premium%20quality&width=80&height=80&seq=milk-cart&orientation=squarish',
      storeName: 'بقالة الأمانة'
    }
  ]);

  const updateQuantity = (id: number, newQuantity: number) => {
    if (newQuantity === 0) {
      setCartItems(prev => prev.filter(item => item.id !== id));
    } else {
      setCartItems(prev => 
        prev.map(item => 
          item.id === id ? { ...item, quantity: newQuantity } : item
        )
      );
    }
  };

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const deliveryFee = 5.00;
  const total = subtotal + deliveryFee;

  return (
    <div className="min-h-screen bg-gray-50 pb-32">
      {/* الهيدر */}
      <div className="bg-white shadow-sm">
        <div className="flex items-center justify-between p-4 pt-12">
          <button onClick={() => navigate(-1)} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <h1 className="text-lg font-bold">سلة التسوق</h1>
          <div className="w-10"></div>
        </div>
      </div>

      {cartItems.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-96">
          <i className="ri-shopping-cart-line text-6xl text-gray-300 mb-4"></i>
          <h2 className="text-xl font-bold text-gray-600 mb-2">السلة فارغة</h2>
          <p className="text-gray-500 text-center mb-6">ابدأ بإضافة منتجات إلى سلتك</p>
          <button
            onClick={() => navigate('/home')}
            className="bg-green-500 text-white px-6 py-3 rounded-lg font-medium"
          >
            ابدأ التسوق
          </button>
        </div>
      ) : (
        <>
          {/* عناصر السلة */}
          <div className="px-4 mt-4">
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <div className="p-4 border-b border-gray-100">
                <h3 className="font-medium text-gray-800">بقالة الأمانة</h3>
                <p className="text-sm text-gray-500">وقت التوصيل: 15-30 دقيقة</p>
              </div>
              
              {cartItems.map((item) => (
                <div key={item.id} className="p-4 border-b border-gray-50 last:border-b-0">
                  <div className="flex items-center space-x-3 space-x-reverse">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-16 h-16 rounded-lg object-cover"
                    />
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-800 text-sm">{item.name}</h4>
                      <div className="flex items-center mt-1">
                        <span className="text-green-600 font-bold text-sm">{item.price} ر.س</span>
                        {item.originalPrice && (
                          <span className="text-gray-400 text-xs line-through mr-2">
                            {item.originalPrice} ر.س
                          </span>
                        )}
                        <span className="text-gray-500 text-xs">/{item.unit}</span>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2 space-x-reverse">
                      <button
                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                        className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center"
                      >
                        <i className="ri-subtract-line text-sm"></i>
                      </button>
                      <span className="w-8 text-center font-medium">{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                        className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center"
                      >
                        <i className="ri-add-line text-sm"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ملخص الطلب */}
          <div className="px-4 mt-4">
            <div className="bg-white rounded-lg shadow-sm p-4">
              <h3 className="font-medium text-gray-800 mb-3">ملخص الطلب</h3>
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">المجموع الفرعي</span>
                  <span className="font-medium">{subtotal.toFixed(2)} ر.س</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">رسوم التوصيل</span>
                  <span className="font-medium">{deliveryFee.toFixed(2)} ر.س</span>
                </div>
                <div className="border-t border-gray-100 pt-2">
                  <div className="flex justify-between">
                    <span className="font-bold text-gray-800">المجموع الكلي</span>
                    <span className="font-bold text-green-600 text-lg">{total.toFixed(2)} ر.س</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* كوبون الخصم */}
          <div className="px-4 mt-4">
            <div className="bg-white rounded-lg shadow-sm p-4">
              <div className="flex items-center space-x-3 space-x-reverse">
                <input
                  type="text"
                  placeholder="أدخل كود الخصم"
                  className="flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm"
                />
                <button className="bg-green-500 text-white px-4 py-2 rounded-lg text-sm font-medium">
                  تطبيق
                </button>
              </div>
            </div>
          </div>

          {/* زر إتمام الطلب */}
          <div className="fixed bottom-16 left-4 right-4">
            <button
              onClick={() => navigate('/checkout')}
              className="w-full bg-green-500 text-white py-4 rounded-lg font-medium text-lg shadow-lg"
            >
              إتمام الطلب - {total.toFixed(2)} ر.س
            </button>
          </div>
        </>
      )}

      {/* شريط التنقل السفلي */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="grid grid-cols-4 h-16">
          <button 
            onClick={() => navigate('/home')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-home-line text-xl mb-1"></i>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center justify-center text-gray-400">
            <i className="ri-search-line text-xl mb-1"></i>
            <span className="text-xs">البحث</span>
          </button>
          <button className="flex flex-col items-center justify-center text-green-500">
            <i className="ri-shopping-cart-fill text-xl mb-1"></i>
            <span className="text-xs">السلة</span>
          </button>
          <button 
            onClick={() => navigate('/orders')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-file-list-line text-xl mb-1"></i>
            <span className="text-xs">طلباتي</span>
          </button>
        </div>
      </div>
    </div>
  );
}